import { Route } from "react-router-dom";
import { lazy } from "react";
const OutreachPublicList = lazy(() => import("./OutreachPublicList"));
const OutreachPublicLView = lazy(() => import("./OutreachPublicView"));


const outreachPublicRoutes = 
<>
    {/* Outreach Public Module Pages */}
	    <Route path="/outreach/public/List" element={<OutreachPublicList />} />
	    <Route path="/outreach/public/View" element={<OutreachPublicLView />} />
</>;

export default outreachPublicRoutes;